// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__nM5cP","link":"Video_link__sVXh9","blackbox":"Video_blackbox__lLb9l"};